import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  providers: [
  ],
  imports: [
    // import the pipe only, without the service (service should be imported from the main project root module)
    TranslateModule.forChild()
  ],
  exports: [
    TranslateModule
  ]
})
export class SDPTranslateModule { }
